// Import store
import storeFactory from "./storeFactory";

export const store = storeFactory();
